import { connect } from 'react-redux';
import { ReduxState } from '../../../ReduxStorage/state';
import { selectSubscriptionPlanSummariesByPlanId } from '../../../ReduxStorage/SubscriptionPlans/selectors';
import { userSuggestionsSelectorJS } from '../../../ReduxStorage/Users/UserSuggest/selectors';
import {
  selectCurrentUserSubscriptionPlanSummaries,
  selectCumulativeUsagesById,
  selectDailyUsagesById,
  selectEducatorSeatsById,
  selectExistingOwnersAndAdmins,
  selectLinkedCoursePaths,
  selectPaymentMethodSummariesById,
  selectBillingPeriodsById,
  selectCurrentSelectedUserSubscription,
  selectUserSubscriptionPlanNamesById,
  selectLinkedInstitutionPaths,
  selectManageSubscriptionsView,
  selectLinkedInstitutions,
  selectCurrentUserSubscriptionPlanDataHasLoaded,
  selectPaymentTransactionsBySubscriptionId,
} from '../../../ReduxStorage/UserSubscriptionPlans/selectors';
import {
  fetchOwnerAndAdmins,
  inviteUserToSubscription,
  revokeUserAccessToSubscription,
  fetchDailyUsageData,
  setCurrentUserSubscriptionPlan,
  manageUserSubscriptionPlan,
  cancelUserSubscriptionPlan,
  updatePaymentMethodClick,
  redirectToSolutionsPage,
  addAdmin,
  setManageSubscriptionView,
  setUpStripeConnect,
  goToStripeConnect,
  fetchSubscriptionPaymentTransactions,
} from '../../../ReduxStorage/UserSubscriptionPlans/dispatchers';
import { getUserSuggestion } from '../../../ReduxStorage/Users/UserSuggest/dispatchers';
import { SubscriptionsAdmin } from './component';
import { currentUserIdSelector } from '../../../ReduxStorage/Auth/selectors';
import {
  createInstitutionPortal,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
} from '../../../ReduxStorage/InstitutionAdmin/dispatchers';
import { currentUserProfileNameSelector } from '../../../ReduxStorage/Users/selectors';
import { makeSelectOptimizelyEnabledFeature } from '../../../ReduxStorage/Optimizely/selectors';
import { OPTIMIZELY_STRIPE_CONNECT_SETUP } from '../../../ReduxStorage/Optimizely/constants';

export const ConnectedSubscriptionsAdmin = connect(
  (state: ReduxState) => {
    return {
      profileName: currentUserProfileNameSelector(state),
      userId: currentUserIdSelector(state),
      currentSelectedUserSubscription: selectCurrentSelectedUserSubscription(
        state
      ),
      paymentMethodSummaries: selectPaymentMethodSummariesById(state),
      educatorSeats: selectEducatorSeatsById(state),
      linkedCoursePaths: selectLinkedCoursePaths(state),
      dailyUsages: selectDailyUsagesById(state),
      cumulativeUsages: selectCumulativeUsagesById(state),
      existingOwnersAndAdmins: selectExistingOwnersAndAdmins(state),
      userSuggestions: userSuggestionsSelectorJS(state),
      userSubscriptionPlans: selectCurrentUserSubscriptionPlanSummaries(state),
      subscriptionPlans: selectSubscriptionPlanSummariesByPlanId(state),
      billingPeriods: selectBillingPeriodsById(state),
      userSubscriptionPlanNames: selectUserSubscriptionPlanNamesById(state),
      linkedInstitutionPaths: selectLinkedInstitutionPaths(state),
      linkedInstitutions: selectLinkedInstitutions(state),
      selectedView: selectManageSubscriptionsView(state),
      hasLoaded: selectCurrentUserSubscriptionPlanDataHasLoaded(state),
      courseMarketplaceEnabled: makeSelectOptimizelyEnabledFeature(
        OPTIMIZELY_STRIPE_CONNECT_SETUP
      )(state),
      paymentTransactions: selectPaymentTransactionsBySubscriptionId(state),
    };
  },
  {
    getUserSuggestion,
    fetchOwnerAndAdmins,
    inviteUserToSubscription,
    revokeUserAccessToSubscription,
    fetchDailyUsageData,
    setCurrentUserSubscriptionPlan,
    manageUserSubscriptionPlan,
    cancelUserSubscriptionPlan, // braintree subscription
    updatePaymentMethodClick, // braintree subscription
    redirectToSolutionsPage, // braintree subscription
    createInstitutionPortal,
    addAdmin,
    setManageSubscriptionView,
    setUpStripeConnect,
    goToStripeConnect,
    fetchSubscriptionPaymentTransactions,
  }
)(SubscriptionsAdmin);
